<template>
  <div class="havya-footer">
    <div class="looking-box">
      <div class="left">
        <p>ARE YOU LOOKING TO TRAVEL ?</p>
        <span>Make A Reservation By Clicking The Button</span>
      </div>
      <!-- <div class="right">
        Book Yours Now
      </div> -->
    </div>
    <div class="connect-box">
      <div class="list">
        <img src="../assets/tel.png" alt="">
        <p>9149205525</p>
      </div>
      <div class="list">
        <img src="../assets/address.png" alt="">
        <p>HOUSE NO 617/14 SHRI SAMARTH KRUPA, GANESHNAGAR LANE 2, NAVI SANGVI PIMPLE GURAV TAL HAV ELI NA PUNE Pune
          Maharashtra 411061</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fotter",
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.havya-footer {
  background-image: url(../assets/fotter.png);
  height: 316px;
  background-size: 100% 100%;
  position: relative;
  padding: 68px 360px 0;
  box-sizing: border-box;

  .looking-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      p {
        margin-bottom: 20px;
        font-size: 32px;
        font-family: Arial, Arial;
        font-weight: 900;
        color: #FFFFFF;
      }

      span {
        display: block;
        font-size: 20px;
        font-family: ArialMT;
        color: #FFFFFF;
      }
    }

    .right {
      padding: 16px 32px;
      border-radius: 28px;
      border: 1px solid #FFFFFF;
      font-size: 16px;
      font-family: Arial, Arial;
      font-weight: normal;
      color: #FFFFFF;
    }
  }

  .connect-box {
    margin-top: 100px;
    display: flex;

    .list {
      display: flex;
      align-items: center;
      margin-right: 40px;

      img {
        margin-right: 10px;
        width: 24px;
        height: 24px;
      }

      p {
        font-size: 14px;
        font-family: KohinoorBangla, KohinoorBangla;
        color: #FFFFFF;
      }
    }

    .list:nth-child(2) {
      margin-right: 0;
    }
  }
}
</style>
